<template>
  <div class="main">
    <Scroll>
      <div class="detail-content">
        <!-- <div class="img">
          <img class="message-img" :src="message.infoImgUrl" />
        </div> -->
        <div class="title">{{ message.title }}</div>
        <div class="center">
          <div class="left">
            <div class="name">
              来源：
              {{ message.infoSource }}
            </div>
          </div>
          <div class="data">
            <img src="@/assets/imgs/游览量.jpg" alt="" />
            <span style="margin-left: 0.1rem">{{ message.viewCount }}</span>
          </div>
          <div class="data">{{ message.publishDate | dateFilter("time") }}</div>
        </div>
        <div class="detail">
          <div
              v-html="message.textContent"
              style="white-space: pre-wrap; font-size: 0.3rem"></div>
        </div>
        <div class="annex" v-if="message.otherFilePath">
          <div>附件：</div>
          <div
              v-for="(item, index) in message.otherFilePath"
              :key="index"
              style="color: blue">
            <span @click="confirmChange(item.value)">
              {{ item.name }}
            </span>
          </div>
        </div>
      </div>
    </Scroll>
  </div>
</template>

<script>
import commonApi from "@/request/commonApi.js";
import { getRenew} from "@/request/flutterBrid";
import Scroll from "../../../components/Scroll";
export default {
  name: "SearchHeader",
  components: { Scroll },
  props: {
    message: Object,
  },
  data() {
    return {
      infoTypeList: [],
    };
  },
  created() {
    this.getInfoTypeSet();
  },
  methods: {
    confirmChange(val) {
      let url = '';
        if (
          location.hostname != "localhost" &&
          location.hostname != "11.8.238.156" &&
          location.hostname != "106.37.238.69"
        ) {
         url =
            "https://sell.chem.petrochina.com.cn/" + val; //生产
        } else {
         url =
            "http://106.37.238.69/"+ val; //测试
       }
       console.log(2222,url);
       getRenew(url,
         (result) => {
           console.log('getRenew调用',result);
      });
    },
    getInfoTypeSet() {
      let params = {
        setCode: "INFO_TYPE",
      };
      commonApi.listCodeSet(params).then((res) => {
        if (res.returnCode === "0") {
          this.infoTypeList = res.result;
          console.log(this.infoTypeList);
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.annex {
  padding: 0.3rem;
  font-size: 0.4rem;
  line-height: 0.5rem;
}
.main {
  flex: 1;
  height: auto;
  overflow: hidden;
  position: relative;
  padding: 0 24px;
  top: 0;
  left: 0;
  right: 0;
}

.data {
  font-size: 30px;
  img {
    width: 0.4rem;
    height: 0.3rem;
  }
}

.detail-content {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .img {
    width: 100%;
    height: 320px;

    .message-img {
      width: 100%;
      height: 100%;
    }
  }

  .title {
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
    color: rgba(51, 51, 51, 1);
    padding: 24px;
  }

  .center {
    display: flex;
    padding: 0 24px;
    justify-content: space-between;
    font-size: 21px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    opacity: 1;
    align-items: center;

    .left {
      display: flex;
      align-items: center;

      img {
        width: 44px;
        height: 44px;
        background: rgba(0, 0, 0, 0);
        border-radius: 50%;
        opacity: 1;
      }

      .name {
        padding-left: 8px;
        font-size: 30px;
      }
    }
  }

  .detail {
    margin-top: 27px;
    margin-bottom: 24px;
    padding: 0 24px;
    font-size: 28px;
    line-height:1.5;
    // color: #8e8b8b;

    p {
      line-height: 32px;
    }
  }
}
</style>
